import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/shadcn/ui/select';

import { useFieldContext } from './form';
import { getFieldError } from './get-field-error';

export interface SelectItem {
  value: string;
  label: string;
}

interface FormSelectProps {
  items: SelectItem[];
  placeholder?: string;
  showErrorMessage?: boolean;
  className?: string;
}

export function FormSelect({
  items,
  placeholder,
  showErrorMessage = true,
  className,
}: FormSelectProps) {
  const field = useFieldContext<string>();

  return (
    <div className="flex flex-col gap-2">
      <Select
        value={field.state.value ?? ''}
        onValueChange={(value) => field.handleChange(value)}
      >
        <SelectTrigger className={className}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {items.map((item) => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {showErrorMessage && field.state.meta.errors.length > 0 && (
        <span className="text-destructive text-sm">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      )}
    </div>
  );
}
